import * as yup from "yup";

export class HttpError extends Error {
  constructor(
    public readonly status: number,
    public readonly data: unknown,
  ) {
    super(`HTTP error ${status}`);
  }
}

const backendErrorSchema = yup.object({
  error: yup
    .object({
      code: yup.string().required(),
      message: yup.string().required(),
      errors: yup.object().optional(),
    })
    .required(),
});

export type BackendError = yup.InferType<typeof backendErrorSchema>;

export const isBackendError = (data: unknown): data is BackendError => {
  return backendErrorSchema.isValidSync(data);
};
